// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Reprocessos_CompletarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/reprocessos/completar/{id}
 *
 * Closes a reprocess by attaching the after photo and marking it completed.
 * The reprocess ID comes from the URL segment, not from the request body.
 */
import { registerContract } from './validate'

export interface Reprocessos_CompletarInput {
photo_after: string
}

registerContract('Reprocessos_CompletarInput', {
  photo_after: { type: 'string',  required: true },
})
